import { Component, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { CasesService } from "src/app/cms/services/cases.service";
import { Case } from "src/app/shared/models/interfaces";

@Component({
  selector: "app-save-case-dialog",
  templateUrl: "./save-case-dialog.component.html",
  styleUrls: ["./save-case-dialog.component.scss"],
})
export class SaveCaseDialogComponent implements OnDestroy {
  actualImage: string | ArrayBuffer = "";

  readonly MAXIMUM_IMAGE_SIZE = 2097152;
  isLoading = false;
  isImageInvalid = false;
  imgUrl = this.data.caseData?.image_url;

  caseData = {
    title: this.data.caseData?.title,
    image: null as File,
    order: 0, // TODO: set order dynamically
    status: this.data.caseData?.status,
    hasReconciliation: this.data.caseData?.hasReconciliation || true, // TODO remove the truth condition,
    applicationType:
      this.data.caseData?.applicationType === "case" ||
        this.data.caseData?.applicationType === "inquiry"
        ? this.data.caseData.applicationType
        : "all",
  };

  constructor(
    public dialogRef: MatDialogRef<SaveCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _caseService: CasesService
  ) { }

  async saveCase() {
    this.isLoading = true;

    const caseFormData = new FormData();

    // "all" (both case & inquiry) is represented server-side as null, so map
    // it back to null here. Then omit every null/undefined field: FormData
    // serializes null to the string "null", so a real null must be signaled by
    // leaving the key out entirely. This also keeps `image` null when no new
    // file is uploaded on edit, instead of clobbering it with the string "null".
    const payload = {
      ...this.caseData,
      applicationType:
        this.caseData.applicationType === "all"
          ? null
          : this.caseData.applicationType,
    };

    for (const [key, value] of Object.entries(payload)) {
      if (value === undefined) continue;
      caseFormData.append(key, value === null ? '' : value); // ✅ send '' for null
    }
    // DEBUG — remove after confirming
    console.log('FormData entries:');
    caseFormData.forEach((val, key) => console.log(key, val));
    try {
      if (this.data.caseData?.id) {
        const updatedCase = await this._caseService
          .updateCase(caseFormData, this.data.caseData?.id)
          .toPromise();

        this.closeDialog(updatedCase);
      } else {
        const savedCase = await this._caseService
          .addCase(caseFormData)
          .toPromise();

        this.closeDialog(savedCase);
      }
    } catch (err) { }
    this.isLoading = false;
  }

  onImgUploaded(event) {
    const uploadedImg = event.target.files[0];
    this.caseData.image = uploadedImg;
    // Not allow to upload image which size is equal or more than 2MB
    this.isImageInvalid = uploadedImg.size >= this.MAXIMUM_IMAGE_SIZE;

    const reader = new FileReader();
    reader.readAsDataURL(uploadedImg);
    reader.onload = (_event) => {
      this.actualImage = reader.result;
    };
  }

  closeDialog(data?: Partial<Case>) {
    this.dialogRef.close(data);
  }

  ngOnDestroy() {
    this.isImageInvalid = false;
  }
}
